import { schema } from 'normalizr';

export const placeTypeSchema = new schema.Entity('placeTypes');
export const placeTypesSchema = new schema.Array(placeTypeSchema);
